import { CalendarDate } from '@internationalized/date'
import { format, parseISO, formatDistanceToNow } from 'date-fns'
import { enUS } from 'date-fns/locale'
import { logError } from '@/composables/useLogger'

export const formatType = (type: string) => {
  return type
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export function formatDateFromUTC(date: string | Date, formatStr: string = 'PPp'): string {
  try {
    const dateObj = typeof date === 'string' ? parseISO(date) : date
    return format(dateObj, formatStr, { locale: enUS })
  } catch (error) {
    logError('Error formatting date:', error)
    return 'Invalid Date'
  }
}

export function formatRelativeTime(date: string | Date): string {
  try {
    const dateObj = typeof date === 'string' ? parseISO(date) : date
    return formatDistanceToNow(dateObj, { addSuffix: true })
  } catch (error) {
    logError('Error formatting relative time:', error)
    return 'Invalid Date'
  }
}

export function formatDate(
  date: Date | CalendarDate,
  options?: Intl.DateTimeFormatOptions
): string {
  try {
    if (date instanceof CalendarDate) {
      date = new Date(date.year, date.month - 1, date.day)
    }
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      ...options,
    })
  } catch (error) {
    logError('Error in formatDate:', error)
    return 'Invalid Date'
  }
}
